import React from 'react'

const PowerBI = () => {
  return (
    <div>
        {/* collapseFiftySeven */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftySeven">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftySeven" aria-expanded="false" aria-controls="collapseFiftySeven">
                    PowerBI <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftySeven" className="accordion-collapse collapse" aria-labelledby="headingFiftySeven" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Introduction to Power BI</strong>
                    <ul>
                        <li>Installation and setup</li>
                        <li>Introduction to Power BI Desktop interface</li>
                        <li>Importing data from various sources</li>
                        <li>Basic data transformations and data shaping</li>
                        <li>Creating simple visualizations (e.g., bar charts, line charts, pie charts)</li>
                    </ul>

                    <strong>Data Preparation and Modeling</strong>
                    <ul>
                        <li>Data cleaning and transformation techniques</li>
                        <li>Understanding relationships in Power BI</li>
                        <li>Creating calculated columns and measures using DAX (Data Analysis Expressions)</li>
                        <li>Introduction to Power Query for data manipulation</li>
                        <li>Working with different data types (e.g., text, numeric, date)</li>
                    </ul>

                    <strong>Advanced Data Modeling</strong>
                    <ul>
                        <li>Understanding complex relationships (many-to-many, bi-directional)</li>
                        <li>Introduction to DAX functions (SUMX, CALCULATE, RELATED, etc.)</li>
                        <li>Introduction to Time Intelligence functions for date analysis</li>
                        <li>Working with hierarchies and drill-downs</li>
                    </ul>

                    <strong>Advanced Visualization Techniques</strong>
                    <ul>
                        <li>Using custom visuals and customizing visual appearance</li>
                        <li>Interactive features (slicers, filters, bookmarks)</li>
                        <li>Creating calculated tables and using them in visualizations</li>
                        <li>Advanced chart types (e.g., waterfall charts, KPIs, maps)</li>
                        <li>Tips for effective storytelling with data visualization</li>
                    </ul>

                    <strong>Sharing and Collaboration</strong>
                    <ul>
                        <li>Publishing reports to Power BI Service</li>
                        <li>Creating and managing workspaces</li>
                        <li>Configuring data refresh schedules</li>
                        <li>Introduction to Power BI mobile app</li>
                        <li>Collaborating with colleagues using Power BI Apps and sharing options</li>
                    </ul>

                    <strong>Power BI Administration and Security</strong>
                    <ul>
                        <li>Implementing row-level security (RLS)</li>
                        <li>Understanding data security options in Power BI</li>
                        <li>Best practices for data governance and compliance</li>
                        <li>Managing data source connections and gateways</li>
                        <li></li>
                    </ul>

                    <strong>Advanced Data Analysis and Insights</strong>
                    <ul>
                        <li>Advanced DAX techniques (iterator functions, advanced filter context)</li>
                        <li>Statistical analysis using DAX functions</li>
                        <li>Forecasting and predictive analytics with Power BI </li>
                        <li>Advanced data visualization techniques for insights</li>
                        <li>Creating dashboards for executive reporting</li>
                    </ul>

                    <strong>Power BI Integration and Automation</strong>
                    <ul>
                        <li>Integrating Power BI with other Microsoft tools (Excel, SharePoint, Teams)</li>
                        <li>Introduction to Power BI APIs and embedding options</li>
                        <li>Automating tasks using Power BI PowerShell cmdlets</li>
                        <li>Using Power Automate (formerly Microsoft Flow) with Power BI</li>
                        <li>Building custom solutions with Power BI Embedded</li>
                    </ul>

                    <strong>Advanced Topics and Case Studies</strong>
                    <ul>
                        <li>Real-world case studies and project examples</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default PowerBI